__turbopack_context__.v({
  "actionPrimary": "state-module__4kP2gq__actionPrimary",
  "actionSecondary": "state-module__4kP2gq__actionSecondary",
  "actions": "state-module__4kP2gq__actions",
  "card": "state-module__4kP2gq__card",
  "errorCode": "state-module__4kP2gq__errorCode",
  "eyebrow": "state-module__4kP2gq__eyebrow",
  "screen": "state-module__4kP2gq__screen",
  "screenWithSiteChrome": "state-module__4kP2gq__screenWithSiteChrome",
  "spinner": "state-module__4kP2gq__spinner",
  "spinnerWrap": "state-module__4kP2gq__spinnerWrap",
  "text": "state-module__4kP2gq__text",
  "title": "state-module__4kP2gq__title",
});
